import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography} from "@mui/material";
import {ThreeDots} from 'react-loader-spinner';
import {useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import useProjects from "../../../hooks/useProjects";

const DeleteProjectDialog = (props) => {

    let businessId = (new URLSearchParams(window.location.search)).get("id");

    const {openDeleteProject, handleClose, project, setIsDeleted} = props;

    const navigate = useNavigate();

    const {deleteProject, deletingProject, deleted} = useProjects();

    const handleDeleteProject = (id) => {
        deleteProject(id);
    }


    useEffect(() => {
        if (deleted){
            setIsDeleted(true);
            handleClose();
            navigate('/view?id=' + businessId);
        }
    }, [deleted])

    return(
        <Dialog open={openDeleteProject} onClose={handleClose} maxWidth={'sm'} fullWidth={'sm'} PaperProps={{style: {boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: 5}}}>
            <DialogTitle  sx={{color:'red'}}>
                Delete Confirmation
            </DialogTitle>

            <Divider />

            <DialogContent sx={{padding: 6, paddingTop: 2}}>
                <Typography sx={{fontSize: 16}}>
                    Are you sure you want to delete <strong>{project?.application_name}</strong>?
                </Typography>
                <br/>
                <Typography sx={{fontStyle:'italic', color:'gray', fontSize: 14}}>
                    Please be aware that the credit balances for the project will be transferred to the Enterprise Account through an automated process.
                </Typography>
            </DialogContent>

            <DialogActions sx={{padding: 6, paddingTop: 0, paddingBottom: 3}}>
                <Button sx={{color: "black", textTransform: "none", fontSize: 14}} onClick={handleClose}>
                    Cancel
                </Button>

                <Button variant="contained" sx={{backgroundColor: "red", borderRadius: 1, textTransform: "none", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px", '&:hover': {backgroundColor: "red", color: "white"}}}
                    onClick={() => handleDeleteProject(project?.id)} 
                    startIcon={deletingProject && <ThreeDots height="20" width="20" radius="9" color="#ffff" ariaLabel="three-dots-loading" visible={true} />}
                >
                    {deletingProject ? "Deleting" : "Confirm"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DeleteProjectDialog